export const FILTERS = [
  {
    category: {
      seating: ['sofa', 'lounge chair'],
      table: ['desk', 'side table'],
      lighting: ['table lamp', 'floor lamp', 'pendant lamp'],
      objects: ['tableware', 'vase', 'textile', 'clock'],
    },
  },
  { brand: ['&Tradition', 'Ferm Living', 'LEMNOS', 'HAY'] },
  {
    designer: [
      'Hee Welling',
      'Viggo Boesen',
      'Space Copenhagen',
      'Hvidt & Mølgaard',
      'Finn Juhl',
      'Anderssen & Voll',
      'Louise Liljencrantz',
      'Arne Jacobsen & Flemming Lassen',
      'Mia Hamborg',
      'Jaime Hayon',
      'John Astbury',
      'Verner Panton',
      'Fabricius & Kastholm',
      'All the Way to Paris',
      'Riki Watanabe',
    ],
  },
];
